"use client";

import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
var _excluded = ["type", "width", "height", "className"];
import React from "react";
import styled from "styled-components";
import { buttonreset } from "../../utils/snippets";
import { _minTapSize_ } from "../../dimensions/sizes";
export default function IconButton(_ref) {
  var _ref$type = _ref.type,
    type = _ref$type === void 0 ? "button" : _ref$type,
    width = _ref.width,
    height = _ref.height,
    className = _ref.className,
    rest = _objectWithoutProperties(_ref, _excluded);
  return (
    /*#__PURE__*/
    // TODO: Add compulsory visually hidden label to improve accessibility (GDS-266)
    React.createElement(Button, _extends({
      type: type,
      $width: width,
      $height: height,
      className: className
    }, rest))
  );
}
var Button = styled.button.withConfig({
  displayName: "IconButton__Button",
  componentId: "sc-19baojp-0"
})(["", ";display:flex;align-items:center;justify-content:center;width:", "px;height:", "px;"], buttonreset, function (props) {
  return props.$width || _minTapSize_;
}, function (props) {
  return props.$height || _minTapSize_;
});